import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { ChannelChangesTable } from './tables/ChannelChangesTable';
import { PlanChangesTable } from './tables/PlanChangesTable';
import { CategoryChangesTable } from './tables/CategoryChangesTable';
import { PackageChangesTable } from './tables/PackageChangesTable';
import { TagChangesTable } from './tables/TagChangesTable';
import { AllChangesTable } from './tables/AllChangesTable';
import { RemovedChannelsTable } from './tables/RemovedChannelsTable';
import { useQuery } from '@tanstack/react-query';
import { changeTrackingQueries } from '@/services/changeTracking/queries';
import type { VersionAwareProps } from '@/features/versions/types';

export function VersionChanges(props: VersionAwareProps) {
  const { data: changes, isLoading } = useQuery({
    queryKey: ['version-changes', props.versionId],
    queryFn: () => changeTrackingQueries.getVersionChanges(props.versionId),
    enabled: !!props.versionId
  });

  return (
    <Tabs defaultValue="all" className="space-y-4">
      <Card className="p-4">
        <TabsList>
          <TabsTrigger value="all">All Changes</TabsTrigger>
          <TabsTrigger value="channels">Channels</TabsTrigger>
          <TabsTrigger value="plans">Plans</TabsTrigger>
          <TabsTrigger value="categories">Categories</TabsTrigger>
          <TabsTrigger value="packages">Packages</TabsTrigger>
          <TabsTrigger value="tags">Tags</TabsTrigger>
          <TabsTrigger value="removed">Removed</TabsTrigger>
        </TabsList>
      </Card>

      <TabsContent value="all">
        <Card className="p-4 border-0">
          <AllChangesTable changes={changes} isLoading={isLoading} />
        </Card>
      </TabsContent>

      <TabsContent value="channels">
        <Card className="p-4 border-0">
          <ChannelChangesTable changes={changes} isLoading={isLoading} />
        </Card>
      </TabsContent>

      <TabsContent value="plans">
        <Card className="p-4 border-0">
          <PlanChangesTable changes={changes} isLoading={isLoading} />
        </Card>
      </TabsContent>

      <TabsContent value="categories">
        <Card className="p-4 border-0">
          <CategoryChangesTable changes={changes} isLoading={isLoading} />
        </Card>
      </TabsContent>

      <TabsContent value="packages">
        <Card className="p-4 border-0">
          <PackageChangesTable changes={changes} isLoading={isLoading} />
        </Card>
      </TabsContent>

      <TabsContent value="tags">
        <Card className="p-4 border-0">
          <TagChangesTable changes={changes} isLoading={isLoading} />
        </Card>
      </TabsContent>

      <TabsContent value="removed">
        <Card className="p-4 border-0">
          <RemovedChannelsTable changes={changes} isLoading={isLoading} />
        </Card>
      </TabsContent>
    </Tabs>
  );
} 